import { Grid, Theme, makeStyles } from "@material-ui/core";
import { ColDef, EditableCallbackParams } from "ag-grid-community";
import { get, isNil } from "lodash";
import React, { useState } from "react";
import { useLogsContext } from "../../../context/LogsContext";
import { LOG_TYPE_CODES } from "../../../data/LogTypeCodes";
import { Log } from "../../../models/Log";

const useStyles = makeStyles((theme: Theme) => ({
	buttons: {},
}));
export const useLogTableData = () => {
	const { state } = useLogsContext();
	const classes = useStyles();

	const formatTime = (nowTime: any) => {
		return (
			nowTime.toLocaleDateString("en-US") + " " + nowTime.toLocaleTimeString()
		);
	};
	const getLogTypeByCodeId = (logTypeCodeId: string) => {
		return get(LOG_TYPE_CODES, `${logTypeCodeId}.description`, " -");
	};

	const backgroundColor = (logTypeCode: string) => {
		return get(LOG_TYPE_CODES, `${logTypeCode[0]}.color`, "#BBBBBB");
	};

	const rows = state.logs?.map(
		({ LogId, Timestamp, Source, Message, LogTypeCode, User }: Log) => ({
			id: LogId,
			Timestamp: Timestamp === null ? null : new Date(Timestamp),
			Source,
			Message: isNil(Message) ? "" : Message.replaceAll("Added", " Added"),
			LogTypeCode: getLogTypeByCodeId(LogTypeCode as string),
			User,
		}),
	);

	const [columnDefs] = useState<ColDef[]>([
		{
			field: "Timestamp",
			headerName: "Time",
			minWidth: 150,
			flex: 4,
			valueFormatter: ({ value }: { value: any }) =>
				value === null ? "" : formatTime(value),
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
			headerClass: "ag-header-cell-centered",
		},
		{
			field: "Source",
			headerName: "Source",
			minWidth: 180,
			flex: 5,
			type: "string",
		},
		{
			field: "Message",
			headerName: "Message",
			minWidth: 100,
			flex: 10,
			type: "string",
		},
		{
			field: "LogTypeCode",
			headerName: "Type",
			minWidth: 130,
			flex: 2,
			cellRenderer: (params: any) => {
				return (
					<>
						<div
							style={{
								padding: "2px 6px",
								borderRadius: 4,
								display: "inline-flex",
								alignItems: "center",
								justifyContent: "center",
								color: "#fff",
								fontWeight: "bold",
								fontSize: "0.75rem",
								backgroundColor: backgroundColor(params.value),
							}}
						>
							{params.value}
						</div>
					</>
				);
			},
		},
		{
			field: "User",
			headerName: "User",
			minWidth: 70,
			flex: 1,
			type: "string",
			valueFormatter: ({ value }: { value: string }) => value || " ",
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
			headerClass: "ag-header-cell-centered",
		},
		{
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid
						container
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
						className={classes.buttons}
					>
						<Grid
							item
							xs={12}
							md={12}
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							{/* <Button style={{}} onClick={(e) => showContextMenu(e, params.data)}>
								<FormatListBulletedSharpIcon color="action" fontSize="small" />
							</Button> */}
						</Grid>
					</Grid>
				);
			},
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: " ",
			sortable: false,
			flex: 1,
		},
	]);

	return { rows, columnDefs };
};
